'use client';

import { Box, Flex } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useParams } from 'next/navigation';
import React from 'react';

import FilterControls from '@features/marketplace/navigation/FilterControls';
import FilterSection from '@features/marketplace/navigation/FilterSection';
import NavigationTitleAndControls from '@features/marketplace/navigation/NavigationTitleAndControls';
import TopBar from '@features/marketplace/navigation/TopBar';
import OrgSettingsModal from '@features/settings/OrgSettingsModal';
import { toPxString } from 'helpers/styles';
import { useStores } from 'stores/rootStore';

const NAVIGATION_TITLE_SECTION_HEIGHT = 32;

const MarketplaceLayout = ({ children }: { children: React.ReactNode }) => {
  const { marketPlaceStore } = useStores();
  const params = useParams();
  const productId = params.productId as string | undefined;

  return (
    <Flex flexDirection="column" flex={1} bg="sidebar.background" height="100dvh" pb={2} px={2}>
      <TopBar />
      <Flex flexDirection="column" flex={1} gap={2} bg="surface.background" p={2}>
        <Flex
          position="sticky"
          top={0}
          w="full"
          zIndex="sticky"
          bg="surface.background"
          height={toPxString(NAVIGATION_TITLE_SECTION_HEIGHT)}
          borderRadius="md"
          alignItems="center"
        >
          <NavigationTitleAndControls
            rightContent={
              productId == null && (
                <Box hideBelow="xl">
                  <FilterControls />
                </Box>
              )
            }
          />
        </Flex>
        <Flex flexDirection="row" flex={1} gap={2}>
          {marketPlaceStore.shouldDisplayFiltersPanel(productId) && (
            <Flex
              position="sticky"
              top={toPxString(NAVIGATION_TITLE_SECTION_HEIGHT)}
              height="fit-content"
              hideBelow="xl"
            >
              <FilterSection />
            </Flex>
          )}
          <Flex w="full" h="full" flexDirection="column" gap={2}>
            {productId == null && (
              <Flex hideFrom="xl" alignSelf="flex-end">
                <FilterControls />
              </Flex>
            )}
            {children}
          </Flex>
        </Flex>
      </Flex>
      <OrgSettingsModal />
    </Flex>
  );
};

export default observer(MarketplaceLayout);
